import { awards as constants } from "store/constants";
import {
	reduceSetItems,
	reduceSetSort,
	reduceSetPaging,
	addItems,
	reduceSetSearch,
} from "store/factories/feed";
import {
	reduceIsFetching,
	reduceSetError,
	fetchableInitialState,
} from "store/factories/fetchable";
import { baseInitialState } from "store/factories/initialState";
import {
	storeAwardsContent,
	getStoredAwardsContent,
} from "utils";


const initialState = {
	content: {
		...fetchableInitialState,
		...((getStoredAwardsContent && getStoredAwardsContent()) ?? baseInitialState.content),
	},
	summary: {
		...fetchableInitialState,
		items: [],
	},
};

function reduceIncomingAction (state = initialState, action) {
	switch (action.type) {
	case constants.AWARD_LIST_IS_FETCHING:
		return {
			...state,
			content: reduceIsFetching(state.content, action),
		};
	case constants.AWARD_LIST_SET_ERROR:
		return {
			...state,
			content: reduceSetError(state.content, action.payload),
		};
	case constants.AWARD_LIST_SET_DATA:
		return {
			...state,
			content: {
				...state.content,
				...action.payload,
			},
		};

	case constants.AWARD_LIST_SUMMARY_IS_FETCHING:
		return {
			...state,
			summary: reduceIsFetching(state.summary, action),
		};
	case constants.AWARD_LIST_SUMMARY_SET_ERROR:
		return {
			...state,
			summary: reduceSetError(state.summary, action.payload),
		};
	case constants.AWARD_LIST_SUMMARY_SET_DATA:
		return {
			...state,
			summary: {
				...state.content,
				items: action.payload,
			},
		};

	case constants.SET_ITEMS:
		return reduceSetItems(state, action);
	case constants.SET_SORT:
		return reduceSetSort(state, action);
	case constants.SET_PAGING:
		return reduceSetPaging(state, action);
	case constants.ADD_ITEMS:
		return addItems(state, action);
	case constants.RESET:
		return initialState;
	case constants.SET_SEARCH:
		return reduceSetSearch(state, action);
	default:
		return state;
	}
}

export function awardList (state = initialState, action) {
	const updatedState = reduceIncomingAction(state, action);

	storeAwardsContent && storeAwardsContent({ ...updatedState.content, search: {} });

	return updatedState;
}

